// src/store/apis/searchApi.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { FASTAPI_URL } from '@/config';

export interface Finding {
  url: string;
  match: string;
  snippet: string;
}

export interface ProgressData {
  pages_seen: number;
  html_pages: number;
  links_total: number;
  bytes_total: number;
  running: boolean;
  completed: boolean;
  cancelled?: boolean;
}

export interface SearchApiResponse {
  progress: ProgressData;
  findings: Finding[];
}

export interface BasicSearchResponse {
  status: string;
  message?: string;
}

export interface SearchTermsRequest {
  search_id: string;
  search_terms: string[];
  exact_search: boolean;
  base_url: string;
  max_pages: number;
}

export const searchApi = createApi({
  reducerPath: 'searchApi',
  baseQuery: fetchBaseQuery({ baseUrl: FASTAPI_URL }),
  endpoints: (builder) => ({
    getSearchResults: builder.query<
      SearchApiResponse | BasicSearchResponse,
      string
    >({
      query: (searchId) => ({
        url: `/search/results/${searchId}`,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      }),
    }),
    startSearch: builder.mutation<BasicSearchResponse, SearchTermsRequest>({
      query: (body) => ({
        url: '/search/terms',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
      }),
    }),
    cancelSearch: builder.mutation<BasicSearchResponse, string>({
      query: (searchId) => ({
        url: `/search/cancel/${searchId}`,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useGetSearchResultsQuery,
  useStartSearchMutation,
  useCancelSearchMutation,
} = searchApi;
